module.exports = __webpack_public_path__ + "img/nadia.14efa610.png";